import { render } from "./VolumeTracker.vue?vue&type=template&id=5011d556&ts=true&lang=pug"
import script from "./VolumeTracker.vue?vue&type=script&lang=ts"
export * from "./VolumeTracker.vue?vue&type=script&lang=ts"

import "./VolumeTracker.vue?vue&type=style&index=0&id=5011d556&lang=scss"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__